var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotOrtho = function SvgHotspotOrtho(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 19.5,
    y: 15.5,
    stroke: "currentColor",
    rx: 2.5,
    transform: "rotate(-180 19.5 15.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 15.5,
    y: 19.5,
    stroke: "currentColor",
    rx: 2.5,
    transform: "rotate(-180 15.5 19.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.1,
    fillRule: "evenodd",
    d: "M7.999 7.999H13a3 3 0 0 1 3 3V16H11a3 3 0 0 1-3-3z",
    clipRule: "evenodd"
  })));
};
export default SvgHotspotOrtho;